import {WidgetEnum} from "../../components/widget/common/WidgetEnum";
import {GridsterItem} from "angular-gridster2";
import {FileStorageDTO} from "../storage/FileStorageDTO";

export class DashboardWidget {
  id!: number;
  widgetId!: number;
  widgetType!: WidgetEnum;
  name!: string;
  colsSize!: number;
  rowsSize!: number;
  colsStart!: number;
  rowsStart!: number;
  userConfig: any = {};
  files?: FileStorageDTO[];
  metricInstanceIds!: number[];

  formExpanded?: boolean = false;

  constructor(widgetType?: WidgetEnum) {

    // initialize start
    this.colsStart = 0;
    this.rowsStart = 0;
    if (!!widgetType) {
      this.widgetType = widgetType;
    }
    this.files = [];
    this.metricInstanceIds = [];

  }

  static clone(item: GridsterItem): DashboardWidget {

    const dw = new DashboardWidget();
    dw.id = item.id as number;
    dw.widgetId = item.widgetId as number;
    dw.widgetType = item.type as WidgetEnum;
    dw.name = item.name as string;
    dw.colsSize = item.cols as number;
    dw.rowsSize = item.rows as number;
    dw.colsStart = item.x as number;
    dw.rowsStart = item.y as number;
    dw.userConfig = item.userConfig;
    dw.files = item.files;
    dw.metricInstanceIds = item.metricInstanceIds;

    return dw;
  }
}
